// FROM: https://github.com/modusign/modusign-client/blob/1f2cc00e317b3cc6ddf42ace319c72036470a423/app/src/components/Modal/SignersWithoutSignatureFieldConfirmModal/SignerList/index.tsx

import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Flex, Text, Tooltip } from '@modusign/design-system';
import { ReactNode } from 'react';

export default function SignerList({ children }: { children: ReactNode }) {
  return (
    <Box
      bg="tableBackgroundNeutralDark"
      borderColor="boxBorderNeutralBase"
      borderStyle="solid"
      borderWidth="1px"
      mt="18px"
      position="relative"
      role="table"
      sx={{
        transition: '0.3s 0s',
      }}
      width="100%"
    >
      <Box display={['none', 'none', 'block']} role="rowgroup">
        <Text
          as="div"
          color="textNeutralLight"
          display="flex"
          fontSize="sm"
          pl={6}
          pr={[6, 0]}
          py={4}
          role="row"
          sx={{
            borderBottom: '1px solid',
            borderColor: 'tableBorderNeutralBase',
          }}
        >
          <Box flexGrow={1} fontSize="sm" role="columnheader" textAlign="left">
            서명자
          </Box>
          <Box role="columnheader" width="120px">
            <Flex justifyContent="center">
              <Box fontSize="sm" mr={1}>
                필수 입력란
              </Box>
              <Tooltip content="텍스트, 체크박스 등 서명자가 필수 입력해야 하는 입력란">
                <Box>
                  <FontAwesomeIcon icon={faQuestionCircle} />
                </Box>
              </Tooltip>
            </Flex>
          </Box>
          <Box fontSize="sm" role="columnheader" width="120px">
            사인/도장
          </Box>
        </Text>
      </Box>
      <Box maxHeight="280px" overflowY="auto" role="rowgroup">
        {children}
      </Box>
    </Box>
  );
}
